const { jQuery } = window;

export default class LikeButton {
  constructor() {
    this.audio = null;
    if (window.HTMLAudioElement) {
      // Browser has support for Audio API
      if (window.Current.user.soundEnabled === "true") {
        // User enables sound setting
        if (window.Current.assethost) {
          // Audio asset exists
          const url = `//${window.Current.assethost}/audios/chime_pretty.mp3`;
          this.audio = new Audio(url);
        }
      }
    }
  }

  init() {
    jQuery(".js-likes-button")
      .on("click", LikeButton.handleClick)
      .on("ajax:before", this.handleAjaxBefore.bind(this))
      .on("ajax:complete", LikeButton.handleAjaxComplete);
  }

  handleAjaxBefore(event) {
    const $element = jQuery(event.currentTarget);
    const method = $element.data("method");
    const currentLikes = Number.parseInt(
      $element.find(".js-likes-button__likes-count").text(),
      10,
    );

    if (method === "post") {
      // 数値をインクリメントして色を変える
      const value = Number.isNaN(currentLikes) ? 1 : currentLikes + 1;
      $element.find(".js-likes-button__likes-count").text(value);
      $element
        .find(".js-likes-button__likes-count")
        .addClass("button--likes__count-exist");
      // アイコンをハイライトにする
      $element
        .find(".js-likes-button__icon")
        .addClass("is-button--likes__icon-turn-on");
      // 操作音を鳴らす
      if (this.audio) {
        this.audio.play();
      }
    } else {
      // 数値をデクリメントして色を変える
      const value = Number.isNaN(currentLikes) ? 0 : currentLikes - 1;
      $element.find(".js-likes-button__likes-count").text(value);
      if (value < 1) {
        $element
          .find(".js-likes-button__likes-count")
          .removeClass("button--likes__count-exist");
      }
      // アイコンをグレーにする
      $element
        .find(".js-likes-button__icon")
        .removeClass("is-button--likes__icon-turn-on");
    }
  }

  static handleAjaxComplete(event, xhr, status) {
    const $element = jQuery(event.currentTarget);

    if (status === "success") {
      const method = $element.data("method");
      $element.data("method", method === "post" ? "delete" : "post");
    } else {
      // アイコンの数値とハイライトを元に戻す
      const currentLikes = Number.parseInt(
        $element.find(".js-likes-button__likes-count").text(),
        10,
      );

      // 数値をインクリメントして色を変える
      const value = Number.isNaN(currentLikes) ? 0 : currentLikes + 1;
      $element.find(".js-likes-button__likes-count").text(value);
      if (value < 1) {
        $element
          .find(".js-likes-button__likes-count")
          .removeClass("button--likes__count-exist");
      }

      // アイコンをハイライトにする
      $element
        .find(".js-likes-button__icon")
        .addClass("is-button--likes__icon-turn-on");
    }

    // 要素から通信中フラグを取り除く
    $element.removeData("ajax-ongoing");
  }

  static handleClick(event) {
    const $target = jQuery(event.currentTarget);
    if ($target.data("ajax-ongoing")) {
      // 要素に通信中フラグが設定されている場合はボタンが機能しないようにする
      return false;
    }
    $target.data("ajax-ongoing", "true");
    return true;
  }
}
